export default __webpack_public_path__ + "static/media/Login Logo.fef751b4.png";